// The quick switcher's matching, and the order channels go in for moving up
// and down with the keyboard.

// score is how well a name matches what was typed: 0 for not at all, then
// letters in order, the start of a word, the start of the name, and best,
// the whole name. Matches alike tie, for what is waiting to decide.
export function score(name: string, query: string): number {
  const n = name.toLowerCase().replace(/^[#@]/, "");
  const q = query.toLowerCase().trim().replace(/^[#@]/, "");
  if (!q) return 1;
  if (n === q) return 100;
  if (n.startsWith(q)) return 80;
  const words = n.split(/[\s\-_.]+/);
  if (words.some((w) => w.startsWith(q))) return 60;
  if (n.includes(q)) return 40;
  // Letters in order, like "eng" for "e2e-engineering" or "rn" for "release-notes".
  let i = 0;
  for (const ch of n) if (ch === q[i]) i++;
  return i === q.length ? 20 : 0;
}

export type Entry = { key: string; label: string; also?: string; unread?: number; rank?: number };

// rank orders entries by how well they match, then by what is waiting in
// them, then by kind (rank), keeping the first limit.
export function rank<T extends Entry>(entries: T[], query: string, limit = 10): T[] {
  return entries
    .map((e) => ({ e, s: Math.max(score(e.label, query), e.also ? score(e.also, query) * 0.9 : 0) }))
    .filter((x) => x.s > 0)
    .sort((a, b) => b.s - a.s || (b.e.unread ?? 0) - (a.e.unread ?? 0) || (a.e.rank ?? 0) - (b.e.rank ?? 0) || a.e.label.localeCompare(b.e.label))
    .slice(0, limit)
    .map((x) => x.e);
}

// step moves from current through ids by delta, wrapping, and only to those
// keep allows when given (the unread ones, say). It returns undefined when
// there is nowhere to go.
export function step(ids: string[], current: string | undefined, delta: 1 | -1, keep: (id: string) => boolean = () => true): string | undefined {
  if (ids.length === 0) return undefined;
  const at = current ? ids.indexOf(current) : -1;
  for (let k = 1; k <= ids.length; k++) {
    const id = ids[(((at + delta * k) % ids.length) + ids.length) % ids.length];
    if (id !== current && keep(id)) return id;
  }
  return undefined;
}
